import { render } from "./PropsSwift.vue?vue&type=template&id=00aa80b6"
import script from "./PropsSwift.vue?vue&type=script&lang=js"
export * from "./PropsSwift.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__